import styled from "styled-components";
import FlexRow from "../../components/FlexRow";
import { TABLET_LANDSCAPE, TYPE_LEADER } from "../../Constants";

const Container = styled.button`
  width: 100%;
  padding: 1.13rem;
  background: ${({ theme, type }) =>
    type === TYPE_LEADER
      ? "linear-gradient(218deg, #2F8171 0%, #1F3733 100%)"
      : theme.primary.normal};
  color: ${({ theme }) => theme.grayScaleColor.white};
  font-weight: 500;
  font-size: 0.9375rem;
  line-height: normal;
  border-radius: 0.75rem;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  @media (max-width: ${TABLET_LANDSCAPE}) {
    ${({ expandSidebar }) => !expandSidebar && "padding: 0.62rem;"}
  }
`;

const UserSvg = () => {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.525 19.8822C7.64856 19.1077 8.76634 18.5073 9.87834 18.0811C10.9904 17.6549 12.1976 17.4418 13.5 17.4418C14.8024 17.4418 16.0125 17.6549 17.1303 18.0811C18.248 18.5073 19.3687 19.1077 20.4923 19.8822C21.31 18.9346 21.9176 17.934 22.315 16.8805C22.7123 15.827 22.911 14.7002 22.911 13.5C22.911 10.8461 22.006 8.61416 20.1959 6.80406C18.3858 4.99397 16.1538 4.08893 13.5 4.08893C10.8461 4.08893 8.61416 4.99397 6.80406 6.80406C4.99397 8.61416 4.08892 10.8461 4.08892 13.5C4.08892 14.7002 4.29049 15.827 4.69361 16.8805C5.09674 17.934 5.7072 18.9346 6.525 19.8822ZM13.4939 14.1382C12.4825 14.1382 11.6318 13.7911 10.9417 13.0969C10.2515 12.4027 9.90647 11.5499 9.90647 10.5386C9.90647 9.52728 10.2536 8.67655 10.9478 7.9864C11.642 7.29627 12.4948 6.95121 13.5061 6.95121C14.5174 6.95121 15.3681 7.29831 16.0582 7.99251C16.7484 8.68671 17.0935 9.53947 17.0935 10.5508C17.0935 11.5621 16.7464 12.4128 16.0521 13.103C15.3579 13.7931 14.5052 14.1382 13.4939 14.1382ZM13.5131 24.1874C12.0318 24.1874 10.642 23.9083 9.34383 23.3502C8.04567 22.792 6.91166 22.0272 5.9418 21.0558C4.97196 20.0844 4.20795 18.9526 3.64978 17.6604C3.09159 16.3681 2.8125 14.9806 2.8125 13.4979C2.8125 12.0151 3.09159 10.6283 3.64978 9.3375C4.20795 8.04664 4.97272 6.91551 5.94411 5.94411C6.91551 4.97273 8.04732 4.20795 9.33955 3.64978C10.6318 3.09159 12.0193 2.8125 13.5021 2.8125C14.9848 2.8125 16.3716 3.09159 17.6624 3.64978C18.9533 4.20795 20.0844 4.97273 21.0558 5.94411C22.0272 6.91551 22.792 8.04694 23.3502 9.3384C23.9083 10.6299 24.1874 12.0127 24.1874 13.4868C24.1874 14.9682 23.9083 16.3579 23.3502 17.6561C22.792 18.9543 22.0272 20.0883 21.0558 21.0581C20.0844 22.028 18.953 22.792 17.6615 23.3502C16.3701 23.9083 14.9873 24.1874 13.5131 24.1874ZM13.5 22.911C14.5456 22.911 15.5769 22.7448 16.5937 22.4123C17.6106 22.0799 18.5682 21.5423 19.4668 20.7995C18.5682 20.1389 17.6167 19.6269 16.6121 19.2634C15.6075 18.9 14.5702 18.7182 13.5 18.7182C12.4298 18.7182 11.3906 18.8982 10.3824 19.258C9.37424 19.6179 8.42809 20.1317 7.54397 20.7995C8.43531 21.5423 9.38939 22.0799 10.4062 22.4123C11.4231 22.7448 12.4543 22.911 13.5 22.911ZM13.5015 12.8618C14.174 12.8618 14.7281 12.6435 15.1637 12.2069C15.5993 11.7703 15.817 11.2157 15.817 10.5432C15.817 9.87063 15.5988 9.31656 15.1622 8.88097C14.7256 8.44539 14.171 8.2276 13.4985 8.2276C12.8259 8.2276 12.2718 8.4459 11.8363 8.88249C11.4007 9.31907 11.1829 9.87364 11.1829 10.5462C11.1829 11.2187 11.4012 11.7728 11.8378 12.2084C12.2744 12.644 12.8289 12.8618 13.5015 12.8618Z"
        fill="white"
      />
    </svg>
  );
};

const AdminSvg = () => {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.3445 19.3306C19.8268 19.3306 20.2367 19.1555 20.5743 18.8052C20.9119 18.4549 21.0807 18.0413 21.0807 17.5645C21.0807 17.0877 20.9109 16.6794 20.5712 16.3397C20.2315 16 19.8232 15.8302 19.3464 15.8302C18.8696 15.8302 18.456 15.9985 18.1057 16.3352C17.7554 16.672 17.5803 17.0809 17.5803 17.5619C17.5803 18.043 17.7552 18.458 18.1052 18.8071C18.4551 19.1561 18.8682 19.3306 19.3445 19.3306ZM19.3164 22.803C19.9373 22.803 20.4991 22.6735 21.0018 22.4146C21.5044 22.1558 21.9266 21.7862 22.2685 21.3059C21.7954 21.0434 21.3178 20.8465 20.8357 20.7152C20.3536 20.584 19.8522 20.5184 19.3316 20.5184C18.8109 20.5184 18.3045 20.584 17.8123 20.7152C17.3201 20.8465 16.8468 21.0434 16.3925 21.3059C16.7343 21.7862 17.1519 22.1558 17.6451 22.4146C18.1384 22.6735 18.6955 22.803 19.3164 22.803ZM13.5 24.1659C11.0856 23.5371 9.0757 22.124 7.47042 19.9266C5.86514 17.7293 5.0625 15.2078 5.0625 12.3621V5.99726L13.5 2.83862L21.9374 5.99726V13.2556C21.7398 13.1677 21.5253 13.0847 21.2938 13.0069C21.0623 12.929 20.8514 12.8749 20.661 12.8446V6.8756L13.5 4.24051L6.33892 6.8756V12.3621C6.33892 13.7583 6.5614 15.0473 7.00636 16.2293C7.4513 17.4113 8.02821 18.457 8.73711 19.3663C9.44601 20.2757 10.2371 21.0322 11.1104 21.6358C11.9838 22.2394 12.8524 22.6652 13.7163 22.9133L13.7488 22.9025C13.8324 23.041 13.9507 23.2039 14.1036 23.3914C14.2565 23.5789 14.3827 23.7224 14.4822 23.822C14.3206 23.9085 14.1551 23.9752 13.9857 24.0221C13.8162 24.0689 13.6543 24.1169 13.5 24.1659ZM19.3844 24.1876C18.0573 24.1876 16.9251 23.7159 15.9878 22.7727C15.0504 21.8294 14.5817 20.703 14.5817 19.3934C14.5817 18.0502 15.0503 16.9078 15.9875 15.9662C16.9246 15.0246 18.0616 14.5538 19.3984 14.5538C20.7161 14.5538 21.8466 15.0246 22.7899 15.9662C23.7331 16.9078 24.2047 18.0502 24.2047 19.3934C24.2047 20.703 23.7331 21.8294 22.7899 22.7727C21.8466 23.7159 20.7114 24.1876 19.3844 24.1876Z"
        fill="white"
      />
    </svg>
  );
};

const ArrowSvg = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7902 6.63775C15.0692 6.91669 15.0692 7.36895 14.7902 7.6479L10.2445 12.1936C9.9656 12.4725 9.51334 12.4725 9.23439 12.1936C8.95545 11.9146 8.95545 11.4624 9.23439 11.1834L13.275 7.14282L9.23439 3.10221C8.95545 2.82327 8.95545 2.37101 9.23439 2.09206C9.51334 1.81311 9.9656 1.81311 10.2445 2.09206L14.7902 6.63775ZM1.42801 7.85711C1.03352 7.85711 0.713727 7.53731 0.713727 7.14282C0.713727 6.74833 1.03352 6.42854 1.42801 6.42854V7.85711ZM14.2852 7.85711H1.42801V6.42854H14.2852V7.85711Z"
        fill="white"
      />
    </svg>
  );
};

const SwitchButton = ({ type, expandSidebar, children, style, onClick }) => {
  return (
    <Container
      type={type}
      expandSidebar={expandSidebar}
      style={style}
      onClick={onClick}
    >
      <FlexRow
        style={{
          alignItems: "center",
        }}
      >
        {type === TYPE_LEADER ? <UserSvg /> : <AdminSvg />}
        <span style={{ marginLeft: "0.31rem" }}>{children}</span>
      </FlexRow>
      <ArrowSvg />
    </Container>
  );
};

export default SwitchButton;
